export const GET_INCENTIVES = "GET_INCENTIVES";
export const UPDATE_INCENTIVE_QUERY = "UPDATE_INCENTIVE_QUERY";
export const GET_INCENTIVE = "GET_INCENTIVE";
export const EXPORT_INCENTIVE_DATA = "EXPORT_INCENTIVE_DATA";